/*
 * Sheeply social fan: every few seconds all cards move one slot
 * along the circle. The card leaving one end jumps (without animation)
 * to the other end, far below the visible arc.
 */
if (!customElements.get('gr-social-fan')) {
  customElements.define(
    'gr-social-fan',
    class GrSocialFan extends HTMLElement {
      connectedCallback() {
        this.orbits = Array.from(this.querySelectorAll('[data-orbit]'));
        if (!this.orbits.length) return;
        this.offset = 0;
        this.layout(false);

        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.interval = (parseInt(this.dataset.interval, 10) || 3) * 1000;
        this.paused = false;
        this.visible = false;

        this.toggle = this.querySelector('[data-fan-toggle]');
        if (this.toggle) {
          this.toggle.addEventListener('click', () => {
            this.paused = !this.paused;
            this.toggle.setAttribute('aria-pressed', String(this.paused));
            this.sync();
          });
        }

        this.observer = new IntersectionObserver((entries) => {
          this.visible = entries.some((entry) => entry.isIntersecting);
          this.sync();
        });
        this.observer.observe(this);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        clearInterval(this.timer);
      }

      sync() {
        clearInterval(this.timer);
        if (this.reduced || this.paused || !this.visible) return;
        this.timer = setInterval(() => {
          this.offset += 1;
          this.layout(true);
        }, this.interval);
      }

      layout(animate) {
        const count = this.orbits.length;
        const half = Math.floor(count / 2);
        this.orbits.forEach((orbit, index) => {
          // position relative to the center slot, wrapped into [-half, count - half)
          let pos = (((index - this.offset) % count) + count) % count;
          if (pos >= count - half) pos -= count;
          const previous = parseFloat(orbit.style.getPropertyValue('--pos'));
          const jumped = !Number.isNaN(previous) && Math.abs(pos - previous) > 1;
          if (!animate || jumped) {
            orbit.classList.add('no-transition');
            orbit.style.setProperty('--pos', pos);
            void orbit.offsetWidth;
            orbit.classList.remove('no-transition');
          } else {
            orbit.style.setProperty('--pos', pos);
          }
        });
      }
    }
  );
}
